var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeemplicity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_33935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88964 18.8988C8.48361 18.8988 10.0763 19.5039 11.2898 20.7168C12.4641 21.8918 13.1113 23.4534 13.1113 25.1136C13.1113 26.7738 12.4641 28.3367 11.2898 29.5118C10.1142 30.6867 8.55187 31.3336 6.88964 31.3336C5.22867 31.3336 3.6663 30.6867 2.49073 29.5118C1.31516 28.3367 0.667969 26.775 0.667969 25.1136C0.667969 23.4534 1.31516 21.8905 2.49073 20.7168C3.70296 19.5051 5.29693 18.8988 6.88964 18.8988ZM25.7796 1.18262C27.4406 1.18262 29.003 1.8295 30.1785 3.00451C31.3541 4.17952 32.0013 5.74115 32.0013 7.40259C32.0013 9.06276 31.3541 10.6256 30.1785 11.7994C28.9663 13.011 27.3723 13.6175 25.7796 13.6175C24.1857 13.6175 22.593 13.0123 21.3795 11.7994C20.2052 10.6256 19.558 9.06402 19.558 7.40259C19.558 5.74115 20.2052 4.17952 21.3795 3.00451C22.555 1.8295 24.1174 1.18262 25.7796 1.18262Z",
    fill: "#36F2BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2112 17.1447L21.4655 17.1491C25.3481 17.2858 28.4551 20.5393 28.4538 24.5359L28.4495 24.7953C28.3155 28.7561 25.1264 31.9245 21.2112 31.9245H11.5106L11.4491 31.9145C11.3719 31.8884 11.3167 31.8145 11.3167 31.7267L11.3228 31.6777C11.3347 31.6306 11.3633 31.5902 11.4017 31.5634L11.4005 31.5621L11.7189 31.3314C12.0327 31.0929 12.3327 30.8309 12.6151 30.5438L12.8457 30.2991C14.272 28.7248 15.0543 26.6913 15.0543 24.5345L15.0479 24.195C14.9659 22.0524 14.1089 20.0505 12.6151 18.5254L12.3252 18.2446C12.0298 17.9729 11.7185 17.7285 11.3967 17.5083V17.5071L11.3609 17.476C11.3289 17.4408 11.3092 17.3941 11.3092 17.3425L11.319 17.2797C11.3446 17.201 11.417 17.1447 11.5031 17.1447H21.2112ZM21.1644 0L21.2253 0.0106497C21.3018 0.0373198 21.3571 0.111041 21.3571 0.197831L21.3506 0.248347C21.3378 0.296515 21.3074 0.336982 21.267 0.363881L21.2683 0.36503L20.9508 0.595566C20.6379 0.833681 20.339 1.09477 20.0585 1.38099L19.8277 1.62574C18.4001 3.20035 17.6176 5.23416 17.6176 7.39121L17.6241 7.73073C17.7061 9.87388 18.5633 11.8761 20.0585 13.4014L20.348 13.6821C20.6427 13.9535 20.9524 14.1976 21.2733 14.4187L21.309 14.4492C21.341 14.4842 21.3605 14.5313 21.3595 14.582L21.3497 14.6448C21.3241 14.7235 21.2517 14.7799 21.1657 14.7799H11.4587L11.2044 14.7754C7.32111 14.6387 4.21484 11.3848 4.21484 7.38994L4.21922 7.13048C4.35318 3.16896 7.54276 0 11.4587 0H21.1644Z",
    fill: "url(#paint0_linear_3125_33935)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3125_33935",
    x1: 4.21482,
    y1: 1596.23,
    x2: 2428.13,
    y2: 1596.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9308C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_33935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeemplicity);
export default __webpack_public_path__ + "static/media/Seemplicity.3273145990b57c38d9dda7455c191f27.svg";
export { ForwardRef as ReactComponent };